module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1be89340b87165479f6.worker.js");
};